import { useParams, Navigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { AlertCircle } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { LEGAL_DOCS } from "@/data/legal";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function LegalPage() {
  const { slug } = useParams();
  const doc = LEGAL_DOCS[slug];

  useDocumentMeta({
    title: doc ? doc.title : "Legal",
    description: doc ? doc.description : undefined,
    path: `/legal/${slug}`,
  });

  if (!doc) return <Navigate to="/" replace />;

  return (
    <div data-testid="legal-page">
      <PageHero eyebrow="Legal" title={doc.title} subtitle={doc.description} current={doc.title} />

      <section className="bg-canvas py-14 md:py-20">
        <div className="max-w-[760px] mx-auto px-6 lg:px-8">
          {/* Draft review note */}
          <div
            data-testid="legal-review-note"
            className="flex items-start gap-3 border border-gold/40 bg-gold/5 px-5 py-4 mb-10"
          >
            <AlertCircle className="w-4 h-4 text-gold mt-0.5 shrink-0" strokeWidth={1.8} />
            <p className="font-sans text-[13px] leading-relaxed text-charcoal/70">
              This is a draft for review — please have counsel finalise the wording before launch.
            </p>
          </div>

          <p className="font-sans text-[11px] tracking-[0.18em] uppercase text-charcoal/45 mb-8">
            Last updated: {doc.updated}
          </p>

          <div data-testid="legal-body" className="article-prose">
            <ReactMarkdown>{doc.body}</ReactMarkdown>
          </div>
        </div>
      </section>
    </div>
  );
}
